module.exports = __webpack_public_path__ + "static/health-smart-behavior-year-2-body-2-d15ae6317ad0e1752040a6097dd3484b.jpg";